import React, { useState, useEffect } from "react";
import "./RangePolygonDetails.css";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";

const RangePolygonDetails = ({ data, toggleView, selectedViews, resetViews, gloablfilter }) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [jsonData, setJsonData] = useState({})
  const appyData = (data) => {
    setJsonData(data);
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "real_time_fault_code/range_polygon",
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    // <div className="range-details-container">
    //   <div className="range-header">Range & Charging Details</div>
    //   <div className="range-content">
    <div className="v-title boxDIC borderDownDIC p-0 indicator_lamp">
      <div className="boxTitleDIC pb-2 pt-2">Range & Charging Details</div>
      {/* <div className="text-start p-4"> */}
      <div className="text-start px-4">
        {/* <div className="range-item">
          <span className="label">Battery:</span>
          <span className="value">{data.Battery_SOC}%</span>
        </div> */}
        {/* <div className="range-item">
          <span className="label">Nearest Charging Station:</span>
          <span className="value">{data.Nearest_charging_station_address}</span>
        </div> */}
        {/* <div className="range-item">
          <span className="label">Distance:</span>
          <span className="value">{data.Distance_to_nearest_charging_station}</span>
        </div> */}

        <div className="toggle-buttons">
          <div className="row">
            <div className="col-6">

              <label>
                <input
                  type="checkbox"
                  checked={selectedViews.includes("polygon")}
                  onChange={() => toggleView("polygon")}
                />
                Range Polygon
              </label>
            </div>
            <div className="col-6">
              <label>
                <input
                  type="checkbox"
                  checked={selectedViews.includes("vehicle")}
                  onChange={() => toggleView("vehicle")}
                />
                Vehicle Location
              </label>
            </div>
          </div>
          <label>
            <input
              type="checkbox"
              checked={selectedViews.includes("charging")}
              onChange={() => toggleView("charging")}
            />
            Charging Stations
          </label>
          <label>
            {console.log("jsonData?.Nearest_charging_station", jsonData?.Nearest_charging_station)}
            <input
              type="checkbox"
              disabled={!(jsonData?.["Nearest_charging_station"]?.length > 0)}
              checked={selectedViews.includes("nearest")}
              onChange={() => toggleView("nearest")}
            />
            Nearest Charging Station
          </label>
        </div>

        {/* Reset Button */}
        <button className="form-control btn btn-primary reset-button" onClick={resetViews}>Refresh</button>
      </div>

      <div className="text-start px-4 pt-2">

        <div className="row py-1">
          <div className="col-6">
            <label className="vehicle_details_data fw-bold d-block">SOC</label>
            <span className="font-weight-bold fs-6">
              {jsonData?.State_of_Charge_SOC !== undefined
                ? `${jsonData.State_of_Charge_SOC} %`
                : "-"}
            </span>
          </div>
          <div className="col-6 position-relative">
            <label className="vehicle_details_data fw-bold d-block">Distance To Empty</label>
            <span className="font-weight-bold fs-6">
              {jsonData?.Distance_to_Empty !== undefined
                ? `${jsonData.Distance_to_Empty} km`
                : "-"}
            </span>
          </div>
        </div>
        <div className="row py-1">
          <div className="col-6">
            <label className="vehicle_details_data fw-bold d-block">Min. Distance</label>
            <span className="font-weight-bold fs-6">
              {jsonData?.min_distance !== undefined
                ? `${jsonData.min_distance.toFixed(2)} km`
                : "-"}
            </span>
          </div>
          <div className="col-6 position-relative">
            <label className="vehicle_details_data fw-bold d-block">Max. Distance</label>
            <span className="font-weight-bold fs-6">
              {jsonData?.max_distance !== undefined
                ? `${jsonData.max_distance.toFixed(2)} km`
                : "-"}
            </span>
          </div>
        </div>
        <div className="py-1">
          <label className="vehicle_details_data fw-bold d-block">Charging Stations Available</label>
          <span className="font-weight-bold fs-6">{jsonData?.Charging_stations_available || "-"}</span>
        </div>
        <div className="py-1">
          <label className="vehicle_details_data fw-bold d-block">Distance To Nearest Charging Station</label>
          <span className="font-weight-bold fs-6">
            {jsonData?.["Distance_to_nearest_charging_station_(km)"] !== undefined
              ? `${jsonData["Distance_to_nearest_charging_station_(km)"]} km`
              : "-"}
          </span>
        </div>
        <div className="py-1">
          <label className="vehicle_details_data fw-bold d-block">Nearest Charging Station Address</label>
          <span className="font-weight-bold fs-6">{jsonData?.Nearest_charging_station_address || "-"}</span>
        </div>
      </div>

    </div>
  );
};

export default RangePolygonDetails;
